import './App.css';
import Home from './Pages/Home/Home';
import NavBar from './Shared-Component/NavBar/NavBar';

function App() {
  return (

    <div className="App">

      <Home/>

    </div>
  );
}

export default App;
